/*
  Simon Miller — sale pricing helper for the cart drawer.

  Shopify's /cart.js payload has no compare_at_price, so the drawer could only ever
  show the markdown price. This caches compare-at per variant from
  /products/<handle>.js, letting the drawer templates render full retail alongside
  the price actually charged, synchronously.

  Also replaces the per-line synchronous jQuery request the drawer templates used
  to make for product tags: those blocked the main thread once per cart line, every
  time the drawer opened.

  Loaded (deferred) in snippets/script-tags.liquid.
*/
(function () {
  var compareAt = {}; // variant_id -> compare_at_price in cents (0 when not marked down)
  var tagsByHandle = {}; // handle -> tags array
  var inflight = {}; // handle -> Promise, so a handle is only fetched once

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve();
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = window
      .fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product) return;
        tagsByHandle[product.handle] = product.tags || [];
        (product.variants || []).forEach(function (variant) {
          compareAt[variant.id] = variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
        });
      })
      .catch(function () {
        inflight[handle] = null; // let a later open retry
      });
    return inflight[handle];
  }

  window.SMSale = {
    // Warm the cache for every line in a cart.js payload. Await before rendering.
    prefetch: function (cart) {
      var items = (cart && cart.items) || [];
      return Promise.all(
        items.map(function (item) {
          return fetchProduct(item.handle);
        })
      );
    },

    tags: function (handle) {
      return tagsByHandle[handle] || [];
    },

    // Full retail if the variant is marked down, otherwise the pre-discount price.
    originalPrice: function (item) {
      return compareAt[item.variant_id] || item.original_price || 0;
    },

    /*
      Cart total for the drawer footer. Guards a case seen in an international
      session: cart.js came back with total_price 0 on a cart holding 6 items,
      and the footer read "SUBTOTAL: USD 0". Falling back to items_subtotal_price
      beats telling a customer their cart is worth nothing.
    */
    subtotal: function (cart) {
      if (!cart) return 0;
      if (!cart.total_price && cart.item_count) {
        return cart.items_subtotal_price || cart.original_total_price || 0;
      }
      return cart.total_price || 0;
    },

    /*
      Matches Liquid's money_without_trailing_zeros, which the rest of the site uses:
      drop ".00" but keep real cents, and group thousands.
        39500 -> "395"      18960 -> "189.60"      129500 -> "1,295"
    */
    money: function (cents) {
      var sign = cents < 0 ? "-" : "";
      var abs = Math.abs(Math.round(cents));
      var whole = Math.floor(abs / 100).toLocaleString("en-US");
      var frac = abs % 100;
      return sign + whole + (frac ? "." + String(frac).padStart(2, "0") : "");
    },
  };
})();
